export const colors = [
    '#3091F6',
    '#FD9C0A',
    '#00CCD7',
    '#FF6A63',
    '#A718A7',
    '#FF9CBD',
    '#9999FF'
];

export const alternateColorSet = [
    '#009999',
    '#ACC62B',
    '#85BFFF',
    '#D84C7C',
    '#33CC99',
    '#808080',
    '#DA2929',
    '#2E66E4',
    '#8758F1',
    '#F62F91'
];

export const sumColor = '#0D148C';

export const presetColors = {
    US: '#3091F6',
    CN: '#FD9C0A',
    GB: '#00CCD7',
    DE: '#FF6A63',
    JP: '#A718A7',
    AU: '#FF9CBD',
    FR: '#9999FF',
    9899: '#3091F6',
    '9899_Bidding': '#ACD3FC',
    9935: '#FD9C0A',
    9928: '#00CCD7',
    9939: '#A718A7',
    '9939_Bidding': '#CF80CF',
    9942: '#FF6A63',
    9917: '#FF9CBD',
    9930: '#9999FF',
    '9930_Bidding': '#CCCCFF',
    9933: '#009999',
    '9933_Bidding': '#7FCCCC',
    9953: '#ACC62B',
    '9953_Bidding': '#D5E295',
    9952: '#DA2A2A',
    '9952_Bidding': '#EC9494',
    3: '#3091F6',
    2: '#FD9C0A',
    8: '#00CCD7',
    240: '#FF6A63',
    1: '#FF6A63',
    A: '#FFC43C',
    B: '#8E44AD',
    totals: sumColor
};

const colorsAssignments = {};
const availableColors = {};

const allColors = () => [...colors, ...alternateColorSet];

export const getColor = (id, fromMap = 'default') => {
    const color = colorsAssignments[fromMap] ? colorsAssignments[fromMap][id] : undefined;

    return color;
};

const filterPresetColors = (ids, colorArr) => colorArr.filter((color) => ids.every((id) => presetColors[id] !== color));

export const getColors = (ids, fromMap = 'default') => {
    if (!colorsAssignments[fromMap]) {
        colorsAssignments[fromMap] = {};
        availableColors[fromMap] = [...colors, ...alternateColorSet];
    }

    availableColors[fromMap] = filterPresetColors(ids, availableColors[fromMap]);

    return ids.map((id) => {
        if (presetColors[id]) {
            colorsAssignments[fromMap][id] = presetColors[id];
            return presetColors[id];
        }

        if (!colorsAssignments[fromMap][id]) {
            let colorOptions = availableColors[fromMap];

            if (!colorOptions.length) {
                colorOptions = filterPresetColors(ids, allColors(fromMap));
            }

            const [nextColor, ...colorsLeft] = colorOptions;
            availableColors[fromMap] = colorsLeft;
            colorsAssignments[fromMap][id] = nextColor;
        }

        return colorsAssignments[fromMap][id];
    });
};

export const clearAssignments = (map = 'default') => {
    colorsAssignments[map] = null;
    availableColors[map] = null;
};
